<template>
  <div :class="$b('')">
    <div :class="$b('preview-image')">
      <LensGuideMainImage
        :all-scenes="scenesToFetch"
        :selected-scene="selectedScene"
        :customised-product="customisedProduct"
        :initial-scenes="initialScenes"
        :selected-lens-colour="lensColour"
        :show-iris-preview="showIrisPreview"
      />
      <div :class="$b('fab-container')">
        <FloatingActionButton
          :options="scenes"
          :active-option-index="sceneOptionIndex"
          :default-expanded="true"
          @click-option="updateScene"
        />
      </div>
    </div>
    <LensTechData
      :class="$b('lens-tech-data')"
      :has-lens-tech-filtering="hasLensTechFiltering"
      :lens-tech-selected="customisedProduct.lensTechSelected"
      :show-iris-preview="showIrisPreview"
      :show-lens-guide-tabs="showLensGuideTabs"
      :show-lens-tech-select="showLensTechSelect"
      :current-tab="currentTab"
      :is-iris="isIris"
      :lens-tech="customisedProduct.lensTech"
      :selected-lens-details="selectedLensDetails"
    />
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'
import { getScenePreviews } from '@/gql/product/lensGuideScene.gql.js'

export default {
  name: 'CondensedLensGuide',
  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
    initialScenes: {
      type: Object,
      default: () => {},
    },
  },
  async setup (props) {
    const previewScenes = computed(() => {
      const previewScenes = props.customisedProduct?.product?.pdpConfig?.lensPreviewScenes
      return previewScenes?.slice(0, 3) || []
    })

    const scenesToFetch = computed (() => {
      const capitalisedNames = previewScenes.value.map((scene) => {
        const formattedName =
          scene.name[0].toUpperCase() + scene.name.substring(1)
        return `"${formattedName}"`
      })
      return `[${capitalisedNames.join(',')}]`
    })

    let scenePreviewImages = []
    if (scenesToFetch.value.length) {
      const gqlQuery = getScenePreviews(scenesToFetch.value)
      const { data: result } = await useDatoQuery({ query: gqlQuery })
      scenePreviewImages = result?.value?.allLensGuideScenes || []
    }

    return {
      previewScenes,
      scenesToFetch,
      scenePreviewImages
    }
  },
  data() {
    return {
      selectedScene: '',
      sceneOptionIndex: 0,
      currentTab: 'Tech',
      showIrisPreview: false,
    }
  },
  computed: {
    scenes() {
      if (!this.scenePreviewImages) return
      const formattedScenes = this.previewScenes.map((scene) => {
        scene.value = scene.name
        scene.image = this.getScenePreviewImage(scene.name)
        return scene
      })
      return formattedScenes
    },
    lensColour() {
      return this.customisedProduct.lensChoice?.skuWithoutLensTech?.split(
        '_'
      )?.[1]
    },
    hasLensTechFiltering() {
      return this.customisedProduct.allowLensTechFiltering
    },
    isIris() {
      return this.customisedProduct.lensChoice.lensTech === 'iris'
    },
    selectedLensDetails() {
      return this.customisedProduct.lensChoice
    },
    showLensGuideTabs() {
      if (this.customisedProduct.isLimitedEdition)
        return this.customisedProduct.product?.baseProduct
          ?.allowLensTechFiltering
      return this.customisedProduct.allowLensTechFiltering
    },
    showLensTechSelect() {
      return true
    },
  },
  beforeMount() {
    this.selectedScene = this.scenes[0]?.name
  },
  methods: {
    getScenePreviewImage(sceneName) {
      const sceneImage = this.scenePreviewImages.find(
        (scene) => scene.sceneName.toLowerCase() === sceneName
      )
      return sceneImage?.nakedEyeImage.src
    },
    updateScene({ idx, value }) {
      this.sceneOptionIndex = idx
      this.selectedScene = value
    },
  },
}
</script>
<style lang="postcss">
.CondensedLensGuide {
  @apply h-full;
}

.CondensedLensGuide__preview-image {
  @apply relative;

  @screen md {
    @apply max-h-[576px] h-full;
  }

  @screen lg {
    @apply max-h-[768px];
  }

  @screen xl {
    @apply max-h-[960px];
  }
}

.CondensedLensGuide__fab-container {
  @apply absolute inset-x-0 top-0 md:w-full
    flex justify-center md:items-start
    p-sm lg:p-md
    z-40;
}

.CondensedLensGuide__lens-tech-data {
  @apply px-sm py-[32px];

  @screen md {
    @apply py-[64px];
  }

  @screen lg {
    @apply px-md;
  }
}
</style>
